import React from 'react'
import Medical from '../../images/medical2.png'

class ContactPage extends React.Component {
  render() {
    return (
      <div className="contact-container">
        <a className="title">Contact Us</a>
        <div className="coverimage">
          <img src={Medical} />
        </div>
        <div className="description">
          <a> We'd love to help! Send us a message or visit us for any help or information.</a>
        </div>
        <div className="twothings">
          <div className="map">
            <div className="icons">
              <div className="onething">
                <i class="fas fa-map-marker-alt"></i>
              </div>
              <div className="onething">
                <i class="fas fa-phone"></i>
              </div>
              <div className="onething">
                <i class="fas fa-envelope-open"></i>
              </div>
            </div>
            <div className="info">
              <div className="onething">
                <a>233 S 7th Ave</a>
                <a>City Of Industry, CA 91746</a>
              </div>
              <div className="onething">
                <a> 626.354.9121</a> 
              </div>
              <div className="onething">
                <a> newsourceproduct@gmail.com</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ContactPage